<div class="front-feature">
    <div class="features">
        <div class="flex-col" *ngIf="machine">
            <div class="flex-row">
                <div class="title">
                    {{ "model" | lang }}
                </div>
                <div class="">
                    {{ machine.machineModelName }}
                </div>
            </div>
            <div class="flex-row">
                <div class="title">
                    {{ "identifier" | lang }}
                </div>
                <div class="">
                    {{ machine.machineName }}
                </div>
            </div>
            <div class="flex-row">
                <div class="title">
                    {{ "horometer-initial" | lang }}
                </div>
                <div class="">
                    {{ machine.hourStart }}
                </div>
            </div>
            <div class="flex-row">
                <div class="title">
                    {{ "fuel-initial" | lang }}
                </div>
                <div class="">
                    {{ machine.fuelStart }}
                </div>
            </div>
        </div>
    </div>
</div>
